import React, { useState, useEffect }                  from 'react';
import FormTable                                       from '../../../reuseableComponents/Form/Form';
import Loader                                          from '../../../reuseableComponents/Loader/Loader';
import Notification                                    from '../../../reuseableComponents/Notification';
import { addRenterApi, getRenterApi, updateRenterApi } from './apis/apis';
import moment from 'moment';

const RenterProfile = () => {
  const [state, setState] = useState({
    renterData: [],
    renterProfile: null,
    initialValues:null,
    loader:true
  })
  let data = [
    {
      label: "Id",
      value: "idCard",
      type: "inp",
      options: []
    },
    {
      label: "Name",
      value: "name",
      type: "inp",
      options: []
    },
    {
      label: "Email",
      value: "email",
      type: "inp",
      options: []
    },
    {
      label: "Phone",
      value: "phone",
      type: "inp",
      options: []
    }
  ]
  const addRenter = async (values) => {
    try {
      let result = await addRenterApi(values)
      if (result?.status) {
        let response = result.data.data;

        const newData = data.map(item =>
          response.hasOwnProperty(item.value)
            ? { ...item, defaultValue: response[item.value], desiredMoveInDate:moment(item.desiredMoveInDate).format("YYYY-MM-DD") }
            : { ...item, defaultValue: null, desiredMoveInDate:moment(item.desiredMoveInDate).format("YYYY-MM-DD") }
        );

        setState({
          ...state,
          renterData: newData
        });
        Notification('success', "Successfully Created", "");
      }
      else {
        Notification('error', "Error", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Error", "Error.");
    }
  };
  const updateRenterFunc = async (values) => {
    try {
      let result = await updateRenterApi(values)
      if (result?.status) {
        let response = result.data.data;

        const newData = data.map(item =>
          response.hasOwnProperty(item.value)
            ? { ...item, defaultValue: response[item.value] }
            : { ...item, defaultValue: null }
        );

        setState({
          ...state,
          renterData: newData
        });
        Notification('success', "Successfully Updated", "");
      }
      else {
        Notification('error', "Error", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Error", "Error.");
    }
  };
  const getRenterProfile = async () => {
    try {
      let result = await getRenterApi();
      if (result?.status) {
        let response = result.data.data;
        const newData = data.map(item =>
          response.hasOwnProperty(item.value)
            ? { ...item, defaultValue: response[item.value] }
            : { ...item, defaultValue: null }
        );

        setState({
          ...state,
          renterProfile: response,
          initialValues: newData,
          loader: false
        });
      }
    }
    catch (err) {
      console.error("Error fetching profile info:", err);
      setState({
        ...state,
        loader: false
      })
    }
  }

  useEffect(() => {
    getRenterProfile()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state.loader ? <Loader/> : <FormTable data={ data } customStyle={
      {
        display: window.innerWidth > 790 ? "grid" : "",
        gridTemplateColumns: window.innerWidth > 790 ? "32% 32% 32%" : "100%",
        justifyContent: "space-between",
        gap: 20,
        width: "100%",
        marginTop: "14%"
      } }
               buttonLabel={ "Save" }
               saveFunc={ state.renterProfile?.id ? updateRenterFunc : addRenter }
                    initialValues={state.initialValues}
    />
}

export default RenterProfile